import styled from 'styled-components'
import { Flex as FlexGrid, Box as BoxGrid } from 'rebass/styled-components'
import { color, border, fontSize, space, textAlign, width, grid, variant, boxShadow } from 'styled-system'

const gridStyle = variant({ key: 'gridStyles', prop: 'variant' })

export const Flex = styled(FlexGrid)`
  ${border}
  ${textAlign}
  ${grid}
  ${({ height }) => height && `height: ${height};`}
  ${gridStyle}
  ${width}
`

Flex.propTypes = {
  ...border.propTypes,
  ...color.propTypes,
  ...fontSize.propTypes,
  ...space.propTypes,
  ...textAlign.propTypes,
  ...width.propTypes
}

export const Box = styled(BoxGrid)`
  ${border}
  ${color}
  ${textAlign}
  ${grid}
  ${({ height }) => height && `height: ${height};`}
  ${gridStyle}
  ${boxShadow}
  ${width}
  // Unless a min-width value is explicitly defined via the minWidth prop, we should 'unset' it
  // to override the Rebass default of min-width: 0, which has caused issues with flexbox layouts.
  // See https://github.com/calibreapp/app/pull/3496/ for more details.
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth};` : `min-width: unset;`)}
`

Box.propTypes = {
  ...border.propTypes,
  ...color.propTypes,
  ...fontSize.propTypes,
  ...space.propTypes,
  ...textAlign.propTypes,
  ...width.propTypes,
  ...boxShadow.propTypes
}

export const InlineFlex = styled(Flex)`
  display: inline-flex;
`

export const InlineBox = styled(Box)`
  display: inline-block;
`
